import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Main from '@/components/Main'
import About from '@/components/About'
import Partner from '@/components/Partner'
import Contact from '@/components/Contact'
import Product from '@/components/Product'
import ProductInfo from '@/components/ProductInfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: '',
          redirect: '/main',
        },
        {
          path: '/main',
          name: 'Main',
          component: Main
        },
        {
          path: '/about',
          name: 'About',
          component: About
        },
        {
          path: '/product',
          name: 'Product',
          component: Product
        },
        {
          path: '/productInfo',
          name: 'ProductInfo',
          component: ProductInfo
        },
        {
          path: '/partner',
          name: 'Partner',
          component: Partner
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact
        },
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js